export const environment = {
    production:false,
    useEmulators:false,
    firebase : {
        apiKey: "AIzaSyCZAscOAknr0jjNjymBek9qVpNR2QY9yAQ",
        authDomain: "narravero-eu-test.firebaseapp.com",
        projectId: "narravero-eu-test",
        storageBucket: "narravero-eu-test.appspot.com",
        messagingSenderId: "251066406205",
        appId: "1:251066406205:web:f4fdb2ff2ccb2f49362154",
        measurementId: "G-QZ5EKYEYD2"
    },
    appCheck: {
        recaptchaSiteKey: '6Lf8QewrAAAAANIhlH7bZtyQM8HLgtaznJtnERlV',
    },
    tagHostName:"https://reader2.narravero.me/",
    urlHostName:"api.narravero.me"

}
